(function () {
  if (!window.location.pathname.endsWith('/collections/airbrush')) {
    return;
  }

  const pagination = document.querySelector('.pagination-wrapper');
  const gridContainer = document.getElementById('ProductGridContainer');

  function getGridItems() {
    const grid = document.getElementById('product-grid');
    if (!grid) {
      return [];
    }

    return [...grid.querySelectorAll('.grid__item[data-ovs-airbrush-role]')];
  }

  function parseList(param) {
    const raw = new URLSearchParams(window.location.search).get(param);
    if (!raw) {
      return [];
    }

    return raw
      .split(',')
      .map((value) => value.trim())
      .filter((value) => value !== '');
  }

  function selectedRoles() {
    const roles = new Set();

    document.querySelectorAll('.ovs-airbrush-role-input:checked').forEach((input) => {
      const role = input.getAttribute('data-ovs-airbrush-role') || '';
      if (role !== '') {
        roles.add(role);
      }
    });

    return [...roles];
  }

  function syncCheckboxLabels() {
    document.querySelectorAll('.ovs-airbrush-role-input').forEach((input) => {
      const label = input.closest('.ovs-airbrush-role-option');
      if (label) {
        label.classList.toggle('active', input.checked);
      }
    });
  }

  function syncPanels(changedInput) {
    const role = changedInput.getAttribute('data-ovs-airbrush-role') || '';
    if (role === '') {
      return;
    }

    document
      .querySelectorAll(`.ovs-airbrush-role-input[data-ovs-airbrush-role="${role}"]`)
      .forEach((input) => {
        input.checked = changedInput.checked;
      });
  }

  function syncCheckboxesFromUrl() {
    const roles = parseList('ovs_airbrush_role');

    document.querySelectorAll('.ovs-airbrush-role-input').forEach((input) => {
      const role = input.getAttribute('data-ovs-airbrush-role') || '';
      input.checked = roles.includes(role);
    });

    syncCheckboxLabels();
  }

  function buildUrl(roles) {
    const url = new URL(window.location.href);
    url.searchParams.delete('ovs_airbrush_role');
    url.searchParams.delete('page');

    if (roles.length > 0) {
      url.searchParams.set('ovs_airbrush_role', roles.join(','));
    }

    return url;
  }

  function updateProductCount(visibleCount) {
    const countNodes = document.querySelectorAll(
      '#ProductCountDesktop, #ProductCountMobile, .product-count__text span',
    );
    countNodes.forEach((node) => {
      if (visibleCount === 1) {
        node.textContent = '1 product';
      } else {
        node.textContent = visibleCount + ' products';
      }
    });
  }

  function togglePagination(roles) {
    if (!pagination) {
      return;
    }

    pagination.hidden = roles.length > 0;
  }

  function setItemVisibility(item, show) {
    item.hidden = !show;
    item.classList.toggle('hidden', !show);
    item.setAttribute('aria-hidden', show ? 'false' : 'true');
  }

  function applyFilters(updateHistory) {
    const roles = selectedRoles();
    let visibleCount = 0;

    getGridItems().forEach((item) => {
      const itemRole = item.getAttribute('data-ovs-airbrush-role') || '';
      let show = true;

      if (roles.length > 0) {
        show = itemRole !== '' && roles.includes(itemRole);
      }

      setItemVisibility(item, show);
      if (show) {
        visibleCount += 1;
      }
    });

    syncCheckboxLabels();
    updateProductCount(visibleCount);
    togglePagination(roles);

    if (updateHistory) {
      const url = buildUrl(roles);
      window.history.pushState({ ovsAirbrushFilters: true }, '', url.pathname + url.search);
    }
  }

  function stopFacetFormPropagation(event) {
    event.stopPropagation();
  }

  document.querySelectorAll('.ovs-airbrush-role-input').forEach((input) => {
    input.addEventListener('input', stopFacetFormPropagation);
    input.addEventListener('change', (event) => {
      stopFacetFormPropagation(event);
      syncPanels(input);
      applyFilters(true);
    });
  });

  window.addEventListener('popstate', () => {
    syncCheckboxesFromUrl();
    applyFilters(false);
  });

  if (gridContainer) {
    const observer = new MutationObserver(() => {
      if (selectedRoles().length > 0) {
        applyFilters(false);
      }
    });

    observer.observe(gridContainer, { childList: true, subtree: true });
  }

  syncCheckboxesFromUrl();
  applyFilters(false);
})();
